/**
 * 조건에 따라 객체 속성을 조건부로 추가하는 유틸 함수
 *
 * @param condition - 조건 값 (boolean, 값, 배열 등)
 * @param keyOrProperties - 키 이름 또는 속성 객체
 * @param value - 할당할 값 (선택사항)
 * @returns 조건이 만족되면 객체, 아니면 빈 객체
 *
 * @example
 * const obj = {
 *   name: 'hello',
 *   ...addIf(user.email, 'email'), // 값이 있을 때만 추가
 *   ...addIf(user.age > 0, 'age', user.age), // 조건이 참일 때만 추가
 *   ...addIf(items?.[0], 'firstItem'), // 배열[0]이 존재할 때만 추가
 *   ...addIf(isAdmin, { adminLevel: 5, role: 'admin' }), // 조건이 참일 때 객체 전체 추가
 * };
 */
const addIf = <T>(
  condition: unknown,
  keyOrProperties: string | Record<string, unknown>,
  value?: T
): Record<string, unknown> => {
  // 조건이 false, null, undefined, 빈 문자열 등인 경우 빈 객체 반환
  if (!condition) return {};

  // 객체 전체를 조건부로 추가하는 경우
  if (typeof keyOrProperties === 'object' && keyOrProperties !== null) {
    return keyOrProperties;
  }

  // 일반적인 조건부 속성 추가
  if (typeof keyOrProperties === 'string') {
    return { [keyOrProperties]: value ?? condition };
  }

  return {};
};

export default addIf;
